import React from "react";

function ShownRowsInfoBlock({ shownRows, total, pageSize }) {
    const calculateShownRows = () => {
        return shownRows < total ? shownRows : total;
    };

    return <div className="tw-flex tw-items-center tw-justify-center tw-mt-6">
        Showing&nbsp;<strong>{calculateShownRows()}</strong>&nbsp;out of&nbsp;<strong>{total}</strong>&nbsp;jobs
    </div>;
}

export default ShownRowsInfoBlock;